export default __webpack_public_path__ + "static/media/Texting 4.a0885984.jpeg";